import React from 'react';
import { useDispatch } from 'react-redux';
import { translate } from "../Services/translation";
import { monitorRemove as removeArticle } from '../Services/Cart.service';
import { loadError, update } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';

const RemoveButton = ({ articleNumber }) => {
    const dispatch = useDispatch();
    console.log(articleNumber);

    const onClick = async ({ articleNumber }) => {
        try {
            const result = await removeArticle({ articleNumber });
            if (result) {
                const row = document.getElementById('row-' + articleNumber);
                if (row !== null) {
                    row.remove();
                }
            }

            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };

    return (
        <a className="table__icon table__icon--delete"
            title={translate(`general.remove`)}
            data-articlenumber={articleNumber}
            onClick={(e) => {
                e.preventDefault();
                onClick({ articleNumber });
            }}
        >
        </a>
    );
};

export default RemoveButton;
